import { useMemo } from 'react'
import ChatGroupDataStoreSelectors from '../selectors/data/ChatGroups'
import ChatGroupDataStoreSlice from '../slices/data/ChatGroupDataStoreSlice'
import StoreChatGroup from '../models/ChatGroup'
import useDataStoreItems from './helpers/useDataStoreItems'
import { isChatGroupActive } from '../../modules/chat/isChatGroupActive'

const JSONStoreChatGroupToStoreChatGroup = JSONStoreChatGroup => StoreChatGroup.FromJSON(JSONStoreChatGroup)

/**
 * Returns requested-/all chatGroup(s) from state.data.chatGroups.
 * Deleted/inactive groups are excluded from list results.
 * @param chatGroupIds {string | string[]}: id of requested chatGroups.
 * @param asMap {boolean}: when multiple chatGroups are requested, return chatGroups as an object mapping chatGroups by their id.
 * @param fetchAllEnabled {boolean}: enable fetching of all devices, when no device id is passed.
 * @returns {StoreChatGroup | StoreChatGroup[]}
 */
const useNormalizedChatGroups = (
  chatGroupIds = null, asMap = false, fetchAllEnabled = false
) => {
  const items = useDataStoreItems(
    chatGroupIds,
    ChatGroupDataStoreSelectors.chatGroups,
    ChatGroupDataStoreSlice.actions.fetch,
    JSONStoreChatGroupToStoreChatGroup,
    asMap,
    fetchAllEnabled
  )

  return useMemo(
    () => {
      if (items == null) return items
      if (Array.isArray(items)) {
        return items.filter(isChatGroupActive)
      }
      if (asMap && typeof items === 'object') {
        return Object.fromEntries(
          Object.entries(items).filter(([, group]) => isChatGroupActive(group))
        )
      }
      return isChatGroupActive(items) ? items : null
    },
    [asMap, items]
  )
}

export default useNormalizedChatGroups
